import React, { PropsWithChildren, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { applyComponentTheme } from '../../../theme';
import { InnerContainer, StyledTableCell, StyledTableHeaderCell } from './styles';

export type TableDataProps = {
  isHeader?: boolean;
  highlight?: boolean;
} & (
  | TdHTMLAttributes<HTMLTableDataCellElement>
  | ThHTMLAttributes<HTMLTableHeaderCellElement>
);

const TableData: React.FC<PropsWithChildren<TableDataProps>> = ({
  highlight,
  isHeader,
  children,
  ...props
}) => {
  const CellType = isHeader ? StyledTableHeaderCell : StyledTableCell;
  return (
    <CellType tabIndex={0} highlight={highlight} {...props}>
      {children !== undefined && <InnerContainer>{children}</InnerContainer>}
    </CellType>
  );
};

export default applyComponentTheme(TableData, 'TableData');
